import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/rem'
import './plugins/vantComponents'
import 'vant/lib/icon/local.css'
import './utils/vee_validate'
import './style/index.less'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
